import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { RxStompState } from '@stomp/rx-stomp';
import { DSignStompWebsocketService } from '../../services/d-sign-stomp-websocket.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppInitService } from '../../services/app-init.service';

@Component({
  selector: 'app-approve-draft-confirmation',
  templateUrl: './approve-draft-confirmation.component.html',
  styleUrls: ['./approve-draft-confirmation.component.scss'],
})
export class ApproveDraftConfirmationComponent implements OnDestroy, OnInit {
  @Output() confirmed = new EventEmitter<boolean>();
  connectionStatusSubscription = new Subscription();
  approveDraftMsg: string = '';
  constructor(
    private dialogRef: MatDialogRef<ApproveDraftConfirmationComponent>,
    private dSignStompWebsocketService: DSignStompWebsocketService,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpClient,
    public appInitService: AppInitService
  ) {}
  ngOnInit(): void {
    if (this.appInitService?.appConfig?.configurableFields?.dSignDraft) {
      this.approveDraftMsg =
        'Do you want to approve this draft and sign digitally?';
    } else {
      this.approveDraftMsg = 'Do you want to approve this draft?';
    }
  }
  ngOnDestroy(): void {
    this.connectionStatusSubscription.unsubscribe();
    this.dSignStompWebsocketService.disconnect();
  }

  onApprove(): void {
    let fileBytes = this.data;
    console.log('fileBytes', fileBytes);
    if (this.appInitService?.appConfig?.configurableFields?.dSignDraft) {
      this.dSignStompWebsocketService.connect();
      this.connectionStatusSubscription = this.dSignStompWebsocketService.websocketStatus.subscribe(
        (status: number) => {
          if (status === RxStompState.OPEN) {
            console.log('Inside websocket');
            let dataForPost = {
              keyStorePassPharse: '1234',
              keyStoreDisplayName: 'eMudra',
              fileType: 'pdf',
              dataTobeSigned: fileBytes,
              keyId: '1234',
            };
            this.http.post(
              '/rest/FileBytesRestServiceProvider/getName',
              dataForPost
            );
          }
        }
      );
    }
    this.confirmed.emit(true);
    this.dialogRef.close();
  }
}
